import { api } from "@/lib/api";

export async function startCheckout() {
  const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}
